import LogoWithName from "../logo/logoWithName.index";

export default function Loader({ hiddenLogo = false }: { hiddenLogo?: boolean }) {
    return (
        <div className="w-full h-full flex flex-col items-center justify-center">
            {!hiddenLogo && <LogoWithName />}
            <div className="lds-ellipsis">
                <div></div>
                <div></div>
                <div></div>
                <div></div>
            </div>
        </div>
    );
}
